<template>
  <base-view title="Integrações com marketplaces" class="mb-5 mr-4">
    <b-row v-if="loading">
      <b-col v-for="index in 4" :key="index">
        <b-card>
          <b-skeleton animation="throb" width="85%"></b-skeleton>
          <b-skeleton animation="throb" width="55%"></b-skeleton>
          <b-skeleton animation="throb" width="70%"></b-skeleton>
        </b-card>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col cols="12">
        <b-alert show class="d-flex align-items-center">
          <div class="mr-3">
            <i class="fas fa-info-circle mr-1"></i>
            Já realizou a integração com algum marketplace? Agora integre os
            seus produtos selecionados para mais plataformas de vendas.
          </div>

          <b-btn
            size="sm"
            variant="primary"
            @click="
              $router.push({
                name: 'lojista-app-marketplaces-integrar-produtos',
              })
            "
          >
            <i class="fas fa-box mr-1"></i> Integrar produtos
          </b-btn>

          <b-btn
            size="sm"
            variant="success"
            class="ml-2"
            @click="
              $router.push({
                name: 'lojista-app-marketplaces-produtos-integrados',
              })
            "
          >
            <i class="fas fa-box-open mr-1"></i> Produtos integrados
          </b-btn>

          <span class="mx-2">ou</span>

          <b-btn
            size="sm"
            variant="warning"
            @click="
              $router.push({
                name: 'lojista-app-marketplaces-acompanhar-integracao',
              })
            "
          >
            <i class="fas fa-eye mr-1"></i> Acompanhar integração
          </b-btn>
        </b-alert>
      </b-col>
      <b-col
        cols="12"
        sm="12"
        md="4"
        lg="4"
        xl="4"
        v-for="marketplace in marketplaces"
        :key="marketplace.id"
      >
        <marketplace-card
          :marketplace="marketplace"
          :loading="cardLoading[marketplace.id]"
          @authorize="getAuthorizationUrl(marketplace)"
          @enable="enable(marketplace)"
          @disable="disable(marketplace)"
          @activate="activate(marketplace)"
          @refresh="getEcommerces"
        />
      </b-col>
    </b-row>
  </base-view>
</template>

<script>
import { mapState } from 'vuex';
import shopkeeperAppApi from '@/api/shopkeeperAppApi';
import UserTypes from '@/enums/UserTypes';
import MarketplaceCard from './_components/MarketplaceCard.vue';

export default {
  name: 'EcommerceIndex',
  computed: {
    ...mapState(['dadosUsuario']),
  },
  data() {
    return {
      loading: false,
      cardLoading: {},
      marketplaces: [],
    };
  },
  mounted() {
    this.getEcommerces();
  },
  methods: {
    async getEcommerces() {
      this.loading = true;

      const { data } = await shopkeeperAppApi.get(
        `/integration/marketplace/${this.userTypeId()}/integrations`
      );

      this.loading = false;

      this.marketplaces = data.data || [];
    },
    async getAuthorizationUrl(marketplace) {
      this.$set(this.cardLoading, marketplace.id, true);

      try {
        const { data } = await shopkeeperAppApi.get(
          `/integration/marketplace/authorization-url?integrationType=${
            marketplace.type
          }&construpUserId=${this.userTypeId()}`
        );

        if (!data.data.url) return;

        window.open(data.data.url, '_blank');
      } finally {
        this.$set(this.cardLoading, marketplace.id, false);
      }
    },
    async enable(marketplace) {
      this.$set(this.cardLoading, marketplace.id, true);

      try {
        await shopkeeperAppApi.get(
          `/integration/marketplace/enable?integrationType=${
            marketplace.type
          }&construpUserId=${this.userTypeId()}`
        );

        this.getEcommerces();
      } finally {
        this.$set(this.cardLoading, marketplace.id, false);
      }
    },
    async disable(marketplace) {
      this.$set(this.cardLoading, marketplace.id, true);

      try {
        await shopkeeperAppApi.get(
          `/integration/marketplace/disable?integrationType=${
            marketplace.type
          }&construpUserId=${this.userTypeId()}`
        );

        this.getEcommerces();
      } finally {
        this.$set(this.cardLoading, marketplace.id, false);
      }
    },
    async activate(marketplace) {
      this.$set(this.cardLoading, marketplace.id, true);

      try {
        await shopkeeperAppApi.get(
          `/integration/marketplace/activate?integrationType=${
            marketplace.type
          }&construpUserId=${this.userTypeId()}`
        );

        this.getEcommerces();
      } finally {
        this.$set(this.cardLoading, marketplace.id, false);
      }
    },
    userTypeId() {
      return this.$route.meta.userType == UserTypes.BALCONISTA
        ? this.dadosUsuario.construp_user_id
        : this.dadosUsuario.id;
    },
  },
  components: {
    MarketplaceCard,
  },
};
</script>
